import { render, staticRenderFns } from "./DatasourceRenamePanel.vue?vue&type=template&id=d9108f84&scoped=true"
import script from "./DatasourceRenamePanel.vue?vue&type=script&lang=js"
export * from "./DatasourceRenamePanel.vue?vue&type=script&lang=js"
import style0 from "./DatasourceRenamePanel.vue?vue&type=style&index=0&id=d9108f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9108f84",
  null
  
)

export default component.exports